import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import productReducer from "./slices/product-slice";
import currencyReducer from "./slices/currency-slice";
import cartReducer from "./slices/cart-slice";
import wishlistReducer from "./slices/wishlist-slice";
import credentialSlice from "./slices/credential-slice";
import addressSlice from "./slices/address-slice";
import orderSlice from "./slices/order-slice";
import menuSlice from "./slices/menu-slice";
import widgetSlice from "./slices/widget-slice";

const persistConfig = {
  key: "Gazelle",
  version: 1.1,
  storage,
};

export const rootReducer = combineReducers({
  product: productReducer,
  currency: currencyReducer,
  cart: cartReducer,
  wishlist: wishlistReducer,
  credential: credentialSlice,
  address: addressSlice,
  order: orderSlice,
  menu: menuSlice,
  widget: widgetSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
